import { Component,
         OnInit,
         Output,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }               from './../common/table-column';
import { TrainCycleService }             from './../shared/train-cycle.service';
import { Globals }                       from './../common/globals';
import { TrainCycleDialogComponent }     from './../train-cycle-dialog/train-cycle-dialog.component';
import { MatDialog }                      from '@angular/material';
import { SavingDialogComponent }         from './../common/saving-dialog.component';
import { TrainCycleDialogModel }         from './../train-cycle-dialog/train-cycle-dialog.model';
import { TrainCycleSortableFilter }      from './train-cycle-sortable-filter';
import { MatSnackBar }                    from '@angular/material';
import { TrainCycleProductDialogComponent } from '../train-cycle-product-dialog/train-cycle-product-dialog.component';
import { TrainCycleSortDialogModel } from '../train-cycle-sort-dialog/train-cycle-sort-dialog.model';
import { TrainCycleSortDialogComponent } from '../train-cycle-sort-dialog/train-cycle-sort-dialog.component';

@Component({
  selector: 'sa-train-cycle-list',
  template: require('./train-cycle-list.component.html'),
  styles: [require('./train-cycle-list.component.scss')]
})
export class TrainCycleListComponent implements OnInit {

  @Output() columns: Array<TableColumn>;
  @Output() filter: TrainCycleSortableFilter = new TrainCycleSortableFilter('name');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  private apiService: TrainCycleService;

  constructor(
    apiService: TrainCycleService,
    private dialog: MatDialog,
    public globals: Globals,
    private snackbar: MatSnackBar
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);

    this.columns = [
      new TableColumn(TableColumnType.Text, 'name', 'Název cyklu', 100),
      new TableColumn(TableColumnType.Text, 'nextName', 'Návazný cyklus', 100),
      new TableColumn(TableColumnType.Bool, 'overNightCycle', 'Návrat následující den', 100),
      new TableColumn(TableColumnType.Number, 'minPercentStockQty', 'Min. procent. zásoba', 100),
      new TableColumn(TableColumnType.Number, 'orderCycleCoef', 'Objednací koeficient', 100),
      new TableColumn(TableColumnType.Text, 'cycleUID', 'Produkty', 100, false, null, false, null,
        (val) => {
          return '<button>Nastavit produkty</button>'
         //return '<button onclick="if(event.stopPropagation){event.stopPropagation();}event.cancelBubble=true; test(\"' + val + '\")" value="' + val + '">test</button>';
      },
        (val) => {
          this.test(val);
      })
    ];
  }

  // private filterChanged(e: any) {
  //   console.log('filterChanged');
  //   this.filter = e;
  //   this.performSearch.emit(e);
  // }

  private getData(filter: TrainCycleSortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew(model: TrainCycleDialogModel = null, error: string = null) {

    let snack = this.snackbar;
    let dialogRef = this.dialog.open(TrainCycleDialogComponent);
    if (model === null) {
      model = new TrainCycleDialogModel();
    }
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = true;

    if (!!error && error.length > 0) {
      dialogRef.componentInstance.errors.push(error);
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(
            res => {
              cloakRef.close();
              snack.open('Úspěšně uloženo.', '', {duration: 2000});
              this.search();
            },
            err => {
              cloakRef.close();
              window.alert(err.message);
            });
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model: TrainCycleDialogModel, error: string = null) {
    let dialogRef = this.dialog.open(TrainCycleDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;
    if (!!error && error.length > 0) {
      dialogRef.componentInstance.errors.push(error);
    }

    let snack = this.snackbar;
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.cycleUID, dialogRef.componentInstance.model)
          .subscribe(
              res => {
                cloakRef.close();
                snack.open('Úspěšně uloženo.', '', {duration: 2000});
                this.search();
            },
              err => {
                cloakRef.close();
                window.alert(err.message);
            });
      } else if (result === 'delete') {
        this.apiService.deleteItem(dialogRef.componentInstance.model.cycleUID)
          .subscribe(
            data => {
              snack.open('Cyklus byl smazán.', '', {duration: 2000});
              this.search();
          },
            err => {
              snack.open('Vybraný cyklus nebylo možné odstranit.', 'Zavřít');
            }
          );
        } else if (result === 'set-products') {
          this.openCycleProductCoefDialog(model);
        } else if (result === 'set-train-order') {
          this.openTrainSortDialog(model);
        } else {
        this.search();
      }
    });
  }

  private openCycleProductCoefDialog(model: TrainCycleDialogModel) {
    let dialogRef = this.dialog.open(TrainCycleProductDialogComponent);

    dialogRef.componentInstance.parentModel = model;

    let snack = this.snackbar;
    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }

  private openTrainSortDialog(model: TrainCycleDialogModel) {
    let dialogRef = this.dialog.open(TrainCycleSortDialogComponent);

    dialogRef.componentInstance.parentModel = model;

    let snack = this.snackbar;
    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }

  public test(event) {
    this.openCycleProductCoefDialog(event);
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-list/train-cycle-list.component.ts